import React from "react";
import { Alert, Typography } from "antd";
import RegistrationBox from "../RegistrationBox";
import { FormFields, useRegistration } from "../../../contexts/RegistrationContext";
import { getRegistrationPlanDefinition } from "../../../utils/agentRegistrationPlans";

const { Title, Paragraph, Text } = Typography;

const TrialActivationStage = () => {
  const { formData, referralLocked } = useRegistration();
  const plan = getRegistrationPlanDefinition(formData[FormFields.ADDITIONAL_INFO.PACKAGE]);

  return (
    <RegistrationBox title="הפעלת חשבון · ניסיון ללא כרטיס">
      <Title level={4} style={{ marginTop: 0 }}>
        {plan?.billing?.displayName || "ניסיון 60 יום"}
      </Title>
      <Paragraph style={{ marginBottom: 8 }}>
        <Text strong>עלות: </Text>
        <Text>ללא עלות למשך 60 יום</Text>
      </Paragraph>
      <Alert
        type="success"
        showIcon
        style={{ marginBottom: 12 }}
        message="לא נדרש כרטיס אשראי"
        description="החשבון נפתח לניסיון בלי שמירת אמצעי תשלום ובלי חיוב."
      />
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message="אחרי 60 יום אין חיוב אוטומטי"
        description="כדי להמשיך בוחרים חבילת BASIC, PRO או סוכנות ושומרים אמצעי תשלום."
      />
      {referralLocked ? (
        <Alert type="info" showIcon message="הקוד נקלט מהלינק" />
      ) : null}
    </RegistrationBox>
  );
};

export default TrialActivationStage;
